<button (click)="login()" mat-button><mat-icon>account_circle</mat-icon> Log in / Signup</button>
